/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Workout_Readiness_LabelInputs */

const en_us2_quick_workout_readiness_label = /** @type {(inputs: Quick_Workout_Readiness_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How are you today? · optional`)
};

const pt_br2_quick_workout_readiness_label = /** @type {(inputs: Quick_Workout_Readiness_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como você está hoje? · opcional`)
};

const es_419_quick_workout_readiness_label = /** @type {(inputs: Quick_Workout_Readiness_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo estás hoy? · opcional`)
};

const pt_pt2_quick_workout_readiness_label = /** @type {(inputs: Quick_Workout_Readiness_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como estás hoje? · opcional`)
};

const fr_fr2_quick_workout_readiness_label = /** @type {(inputs: Quick_Workout_Readiness_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment te sens-tu aujourd'hui ? · facultatif`)
};

const de_de2_quick_workout_readiness_label = /** @type {(inputs: Quick_Workout_Readiness_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie geht's dir heute? · optional`)
};

const it_it2_quick_workout_readiness_label = /** @type {(inputs: Quick_Workout_Readiness_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come stai oggi? · facoltativo`)
};

/**
* | output |
* | --- |
* | "How are you today? · optional" |
*
* @param {Quick_Workout_Readiness_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_readiness_label = /** @type {((inputs?: Quick_Workout_Readiness_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Readiness_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_readiness_label(inputs)
	if (locale === "es-419") return es_419_quick_workout_readiness_label(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_readiness_label(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_readiness_label(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_readiness_label(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_readiness_label(inputs)
	return en_us2_quick_workout_readiness_label(inputs)
});
export { quick_workout_readiness_label as "quick-workout.readiness_label" }